<div class="button-container">
	<button class="btn btn-sm cv-btn-light" (click)="openModal()">
		<i class="fas fa-plus-square"></i> {{title}}
	</button>
</div>
